module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Regular-279644435a7abe79260f0e5e9eefeb4f.eot";